import React, { Component } from 'react';
import FormOffers from './components/FormOffers';
import 'sweetalert/dist/sweetalert.css';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import WaitingModal from '../generics/WaitingModal';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import moment from 'moment';
import 'sweetalert/dist/sweetalert.css';

var Config = require('../../config');

const style = {
  margin: 7,
};

class OffersNew extends Component{
	constructor(props) {
	    super(props);
	    this.saveItem = this.saveItem.bind(this);
	    this.isValidAge = this.isValidAge.bind(this);
	    this.getDonor = this.getDonor.bind(this);
	    this.init = this.init.bind(this);
	    this.cancel = this.cancel.bind(this);
		this.disableElementsView = this.disableElementsView.bind(this);
		this.can_be_edit = this.can_be_edit.bind(this);
		this.getPatientNumber = this.getPatientNumber.bind(this);
	    this.state = {
	    	saved:false,
	    	alerts_age_donor:{},
	    	donor_id:"",
	    	offer_id:"",
	    	donor_person_id:"",
	    	patient_person_id:"",
	    	address_id:null,
	    	patient_id:"",
	    	show_promotion:false,
	    };
	}

	componentWillMount() {
		

		if(this.props.location.pathname.indexOf('promotion') !== -1){
			this.setState({show_promotion:true});
		}
    	//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion/12',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.waiting_modal.handleShow('Cargando...');
			this.setState({
		      alerts_age_donor: response
		    });
		})

		//Get Offer
		fetch(Config.default.apiGateway.URL+'offers/'+this.props.match.params.id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.form.setState({
				relationship:response.item.patient_relationship,
				national_center_id:response.item.national_center_id,
				national_name:response.item.patient_section_name,
				emergency_level: response.item.emergency_level,
				flag_notes:response.register_notes
			});
			this.getDonor(response.item, response.timestamp_date, response.timestamp_hour);
			this.setState({donor_id:response.item.donor_id,offer_id:response.item.id});
			
			
		})
  	}

  	init(){
  		if(this.props.match.params.caller_id === undefined || this.props.match.params.caller_id === '0')
  			this.form.setState({option:"edit"});
  		else
  			this.form.setState({option:"view"});
	  }
	  
	getPatientNumber(){
		fetch(Config.default.apiGateway.URL+'patients/next_patient_number', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.form.setState({patient_number: response})
			}
		})
	}

  	getDonor(offer, timestamp_date, timestamp_hour){
  		//Get Offer
		fetch(Config.default.apiGateway.URL+'donors?id='+offer.donor_id+'&offer_id='+offer.id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.init();

			//Setear datos del donante
			if(this.props.match.params.caller_id === undefined){
				this.form.setInfoDonor(response);
			}
			if(offer.patient_id !== null){
				this.form.specialFields(0, 1);
			}

			setTimeout(()=>{
				this.form.setState({
					special_values: response.offer.special_fields_values,
					show_campaigns: response.offer.campaign_id !== null ? true : false,
					campaign_id: response.offer.campaign_id
				});

				

				this.form.setAnswers(response.offer.special_fields_values)
			}, 500);

			fetch(Config.default.apiGateway.URL+'donation_rules?option=donation_extraction&donation_extraction_id='+offer.donation_type_extraction_id,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			        'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				this.form.offer.setState({
			      donation_types: response
			    });

			    //setear datos del paciente
				for(var i=0; i < this.form.offer.state.donation_types.length;i++){
					if(parseInt(this.form.offer.state.donation_types[i].donation_type.id,10) === offer.donation_type_id){
						if(this.form.offer.state.donation_types[i].donation_type.patient_required===1){//La donacion requiere paciente
							this.form.setState({show_patient_data: true});

							//get patient data
							if(offer.patient_id !== null){

								fetch(Config.default.apiGateway.URL+'person?id='+offer.patient_id+'&option=by_patient_id',{ 
								    method: 'get',
								    headers: new Headers({
								       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
								       'Accept': 'application/json',
								       'Content-Type': 'application/json',
								    })
								})
								.then(response => response.json())
								.then(response => {
									this.form.setInfoPatient(response);
								})
								this.setState({patient_id:offer.patient_id});
							}	
						}else{
							this.form.setState({show_patient_data: false});
						}
					}
				}
			})

			this.setState({address_id:response.address.id});
			
			if(this.props.match.params.caller_id === undefined){
				//setear datos d la donacion
				this.form.setState({
					convoke_places_id:offer.convoke_places_id, 
					donation_type_extraction_id:offer.donation_type_extraction_id,
					day_sesion_donation:offer.work_session_id,
					timestamp_hour:timestamp_hour,
					timestamp_date:timestamp_date,
					timestamp:timestamp_date+' '+timestamp_hour,
					donation_type_id:offer.donation_type_id,
					donor_person_id:response.donor.id,
					offer_id:offer.id,
					patient_person_id:response.person_patient!==null?response.person_patient.id:""
				});
			}else{
				this.form.setState({
					convoke_places_id:offer.convoke_places_id, 
					donation_type_extraction_id:offer.donation_type_extraction_id,
					timestamp_hour:timestamp_hour,
					timestamp_date:timestamp_date,
					timestamp:timestamp_date+' '+timestamp_hour,
					donation_type_id:offer.donation_type_id,
					donor_person_id:response.donor.id,
					patient_person_id:response.person_patient!==null?response.person_patient.id:"",
					disableOnView:true,
					offer_id:offer.id
				});	

				this.disableElementsView();
				
				if(this.props.match.path.indexOf('offers/edit/') === -1){
					this.form.setState({
						blockFieldsPatient:true,
						hc_status: response.clinic_history_status
					});
				}
			}

			this.waiting_modal.handleClose();

			if(this.props.match.params.caller_id === undefined || this.props.match.params.caller_id !== undefined){
				setTimeout(function(){
					this.form.setOfferId(this.state.offer_id,this.state.donor_id);
				}.bind(this), 1000);
			}


			if(this.state.show_promotion){
				var convokes = this.form.offer.state.convoke_places;
				var id = parseInt(response.offer.campaign_id);
		    	var index = this.form.state.campaigns.findIndex(obj =>
		    		obj.id === id
		    	)

				convokes.push(this.form.state.campaigns[index]);
				this.form.offer.setState({
		    		convoke_places: convokes
		    	});
		    	this.setState({
		    		convoke_places_id: this.form.state.campaigns[index].convoke_places_id
		    	});

		    	document.getElementById('convoke_places_id').disabled = true;
			}
				

		})

		if(this.props.match.params.caller_id !== undefined){
			this.form.getInfo(offer.donor_id);
		}	
  	}

	//Funcion Submit Form
	saveItem(e){
		e.preventDefault();
    	if (this.isValidForm()) {
    		if(this.isValidaDate(this.form.state.birthday)){
				var obj = {};
				var error = '';
	    		obj.answers = this.form.getAnswers();
		      	obj.offer = this.form.getOffer();
		      	obj.offer.id = this.state.offer_id;
		      	obj.offer.donor_id = this.state.donor_id;
		      	obj.person = this.form.getPerson();
		      	obj.address = this.form.getAddress();
		      	if(this.state.address_id !== null){
		      		obj.address.id = this.state.address_id;
		      		obj.person.address_id = this.state.address_id;
		      	}
		      	obj.photo = this.form.getPhoto();
		      	obj.fingerprint =this.form.getFingerprint();
		      	obj.fingerprint_img = this.form.getFingerprintImg();
		      	obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		      	obj.incident=0;
		      	if (this.form.state.show_patient_data === true) {
		      		obj.person_patient = this.form.getPersonPatient();
		      		if(obj.person_patient.patient.length > 0){
		      			obj.offer.patient_id = obj.person_patient.patient[0].id;
					}
					
					if(obj.person_patient.birthday !== ""){
						if(!this.isValidaDate(obj.person_patient.birthday.split(/\//).reverse().join('/'))){
							error = 'Fecha de nacimiento de paciente es incorrecta';
						}else{
							//obj.person_patient.birthday = obj.person_patient.birthday.split(/\//).reverse().join('/');
						}
					}
					
				  };
				obj.edit_donation = false;

				/*if(this.form.state.error_email !== ""){
					error = 'Correo electrónico no tiene un formato correcto';
				}*/

				var index = this.form.state.required_fields.findIndex(obj => 
					obj.field.toUpperCase() === 'DONOR_PHONE'
				);
				if(index !== -1){
					if(obj.person.phones.length === 0){
						error = "Debe agregar por lo menos un número de teléfono";
					}
				}

				var mpio = document.getElementById('MUNICIPIO').value;
				
				if(mpio !== "" && obj.address.municipio === ""){
					error = 'No se seleccionó un municipio del catálogo';
					document.getElementById('MUNICIPIO').classList.add('error');
				}


				if(error === ''){
					if(this.isValidAge(obj) === true){
						this.can_be_edit(obj);
					}
				}else{
					notify.show('Error, '+error,'error');
				}

		      
		    }else{
				notify.show('Error, Fecha de Nacimiento no válida','error');
			}			
	    } else {
	    	notify.show('Error, Campos Incompletos','error');
	    }
	}

	isValidaDate(fecha){
		//if(document.getElementById('birthday').required){
			console.log(fecha)
			var arr = fecha.toString().split("/");
			for(var i=0; i< arr.length;i++){
				if (!/^([0-9])*$/.test(arr[i]))
					return false;
			}
			var fecha_aux = new Date(fecha.split(/\//).reverse().join('/'));
			if(fecha_aux.toString() === 'Invalid Date')
				return false;
			
			return true;
		/*}else{
			return true;
		}*/
	}

	isValidAge(obj){
		var items = this.form.offer.state.donation_types;
		var donation_type_id = obj.offer.donation_type_id;
		var res = true;
		for(var i =0; i < items.length;i++){
			if(parseInt(donation_type_id,10) === items[i].rules.donation_type_id){
				//Si la edad del donante no esta en el rango valido de donacion
				if(obj.offer.donor_age  < items[i].rules.age_min || obj.offer.donor_age > items[i].rules.age_max){
					if(this.state.alerts_age_donor.value === "YES"){
						swal({
				        title: '¡Valores fuera de rango! \n ¿Desea guardar?',
				        text: "La edad de donacion permitida es de "+items[i].rules.age_min+' a '+items[i].rules.age_max+" años",
				        type: 'warning',
				        showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true,
				    }, function (isConfirm) {
				        if (isConfirm) {
				        	obj.incident = 1;
				        	this.can_be_edit(obj);
				        	return true;
				        }else{
				        	return false;
				        }
				    }.bind(this));
					}else{
						swal({
					        title: 'No es posible guardar',
					        text: "La edad de donación permitida es de "+items[i].rules.age_min+' a '+items[i].rules.age_max+" años",
					        type: 'error'
					    });
					}
					res = false;
				}
			}
		}
		return res;
	}

	can_be_edit(obj){
		fetch(Config.default.apiGateway.URL+'offers/can_be_edit?offers_id='+obj.offer.id+"&donation_type_id="
					+obj.offer.donation_type_id+"&extraction_type_id="+obj.offer.donation_type_extraction_id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				if(response.res === "success"){
					this.putOffer(obj);
				}else{//MOSTRAR ALERTS
					var msg = "";
					var msg = "<table class='table' style='text-align:left;'>"+
                          "<thead>"+
                            "<tr>"+
                              "<th style='text-align:center'></th>"+
                            "</tr>"+
                          "</thead>"+
                          "<tbody>";
					for(var i =0;i < response.warnings.length;i++){
						msg += "<tr>"+
								"<td style='font-size:1.3em'>"+response.warnings[i]+"</td>"+
								"</tr>";
					}
             	
             		msg += "</tbody></table>";
					swal({
						title: '¡Atención, se eliminarán los siguientes registros!',
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#DD6B55',
						confirmButtonText: '¡Si, Continuar!',
						cancelButtonText: '¡No, Cancelar!',
						closeOnConfirm: true,
						closeOnCancel: true,
						html:true,
	                	text: msg,
					}, function (isConfirm) {
						if (isConfirm) {
							obj.edit_donation = true;
							this.putOffer(obj);
						}
					}.bind(this));
				}
			}
		});
	}

	validBirthdate(){
		var aux_date = new Date();
		var hoy = aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
		hoy = moment(hoy, 'DD-MM-YYYY').format('DD-MM-YYYY');

		var birth = moment(this.form.state.birthday,'DD-MM-YYYY').format('DD-MM-YYYY');
		var date_ok = true;

		if(hoy !== 'Invalid date' && birth !== 'Invalid date'){
			if(moment(hoy) < moment(birth)){
				date_ok = false;
			}
		}else{
			date_ok = false;
		}		

		return date_ok;

	}

	putOffer(obj){
		if(this.validBirthdate()){
			this.waiting_modal.handleShow('Guardando...');
	      	fetch(Config.default.apiGateway.URL+'offers/'+obj.offer.id, {
			  method: 'PUT', // or 'PUT'
			  body: JSON.stringify(obj), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			})
			.then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result){
						swal('Error', result, 'error');
					})
				}
			})
			.then(response => {
				if(response != undefined){
					notify.show('Registro Actualiado','success');
					this.props.history.goBack();
				}
			});
		}else{
			setTimeout(()=>{
				swal('Error', 'La Fecha de Nacimiento no puede ser mayor a la fecha de hoy', 'error');
			}, 500);
			
		}
			
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {
	    	if(input.id === 'state'){
	    		input.id = 'ESTADO';
	    	}
	    	var index = this.form.state.required_fields.findIndex(obj => 
	    		obj.field.toUpperCase() === input.id.toUpperCase()
	    	);


	    	if(index !== -1){
	    		//if(this.form.state.required_fields[index].required){
	    			var control = document.getElementById(input.id);

	    			if(control !== null){
	    				if(control.value === ""){
							control.classList.add('error');
				        	//isFormValid = false;
				        	vacio = true;
				   
						}else{
							if(control.className.includes('error')){
								control.classList.remove('error');
								//isFormValid = true;
							}
							
						}
	    			}
	    		//}
	    	}else{
	    		if(input.required){
			      	const isInputValid = this.form.showCtrlError(input.id);
			      	if (!isInputValid) {
			        	//isFormValid = false;
			        	vacio = false;
			    	}
			  	}
	    	}

	    });

	    if(vacio){
	    	isFormValid = false;
	    }

	    return isFormValid;
	}

	disableElementsView(){
		const inputs = document.querySelectorAll('select,input, button');

	    inputs.forEach(input => {
	    	var control = document.getElementById(input.name);
	    	if(control !== null)
	    		control.setAttribute("disabled","disabled");
	    	else
	    		input.setAttribute("disabled", true);
	    });
	}

	cancel(e){
		if(this.props.location.state === undefined){
			this.props.history.goBack();
		}else{
			if(this.props.location.state.from === 'extraction'){
				this.props.history.push(
					'/extractions/new/'+this.props.match.params.id+'/'+this.props.match.params.donor_id+'/'+
					this.props.match.params.donation_id+'/'+this.props.match.params.extraction_incident_id+'/'+
					this.props.match.params.caller+'/'+this.props.match.params.donation_number
				)
			}
		}
		
		
	}

	//Contenido de la pantalla para el alta de un nuevo registro
	render(){
		const { t } = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
				        Donantes -> 
				        Ofrecimiento
					</h5>
				</div>
		        <form noValidate>
		        	<FormOffers {...this.props} disableElementsView={this.disableElementsView} 
		        		onRef={ref => (this.form = ref)} 
						agenda={false}
						getPatientNumber={this.getPatientNumber}
		        		show_promotion={this.state.show_promotion}/>
		        	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
		        	<Notifications />
		        </form>
		        <div className="col-xs-12 col-sm-9" style={{textAlign:'center'}}>
		        	
		        	<RaisedButton disabled={this.form!==undefined ? this.form.state.option==='view' ? true : false : false} 
		        		label={t('content.generics.buttons.save')} 
		        		className="action-btn" onClick={this.saveItem} style={style}/>
		        	<RaisedButton label={t('content.generics.buttons.return')} onClick={this.cancel} 
		        		className="action-btn" style={style}/>
		        	
		        </div>
		    </div>
		);
	}
}

export default translate('translations')(OffersNew)